var component = /-?\d+(\.\d+)?%?/g;
function extractComponents(color) {
  return color.match(component);
}

module.exports = extractComponents;


//////////////////
// WEBPACK FOOTER
// ./node_modules/pure-color/parse/extractComponents.js
// module id = 98
// module chunks = 0 1